var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Singleton } from '~/services/service.base';
import { makeObservable, observable, action } from 'mobx';
export let ServicePaginator = class ServicePaginator {
    paginatorData;
    constructor() {
        makeObservable(this);
        this.paginatorData = this.getDefaultPaginatorData();
    }
    setOffset(offset) {
        this.paginatorData.offset = offset;
    }
    setPage(page) {
        this.paginatorData.page = page;
    }
    setLimit(limit) {
        this.paginatorData.limit = limit;
    }
    resetPaginatorData() {
        this.paginatorData = this.getDefaultPaginatorData();
    }
    getDefaultPaginatorData() {
        return {
            offset: undefined,
            limit: 50,
            page: 1,
        };
    }
};
__decorate([
    observable,
    __metadata("design:type", Object)
], ServicePaginator.prototype, "paginatorData", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ServicePaginator.prototype, "setOffset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ServicePaginator.prototype, "resetPaginatorData", null);
ServicePaginator = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServicePaginator);
